import {Injectable} from '@angular/core';
import {ApiService} from './api.service';
import {map} from 'rxjs/operators';
import {SiteInfosService} from './site-infos.service';
import {ViewResa} from '../models/view-resa.model';
import {Room} from './../models/room.model';
import {AvailLine} from './../models/availibility.model';
import {Line} from './../models/line.model';
import {Detail} from './../models/view-resa.model';
import {WindowRefService} from './../window-ref.service';
AvailLine

const routes = {
    viewresa: '/viewresa',
    sendCard: '/sendcard',
    sendCardNormal: '/sendcardnormal',
};
@Injectable({
    providedIn: 'root'
})
export class ViewResaService {
    rooms: Array<Room>;
    constructor(private siteInfosService: SiteInfosService, private apiService: ApiService,private winRef:WindowRefService) {
        this.rooms = this.siteInfosService.getChambre();
    }

    /**
     * load data siteInfos - used by module core
     */
    getViewResa(resaAuth, isUpdateCard: boolean = false) {
        let params = {param: resaAuth, idetab:this.winRef.appConfigSite.idEtab, isUpdateCard: isUpdateCard};
        return this.apiService.post(routes.viewresa, params)
            .pipe(map((res: any) => {
                if(!!res.status) {
                    return res.response
                } else {
                    return null;
                }
                //                let viewresa = new ViewResa();
                //                viewresa.setEtabData(this.siteInfosService.getEtabData())
                //                viewresa.setClient(res.response);
                //                viewresa.bindData(res.response);
                //                for (let r of res.response.detail.rooms) {
                //                    let li = new Line();
                //                    li.bindingData(new AvailLine(r.line));
                //                    let detail = new Detail(li, r.id, r.ocupation, r.lit, r.occupants);
                //                    viewresa.setDetail(detail);
                //                }
                //                return viewresa;

            }));
    }
    
    sendCardPci(resaAuth: string, cardValue) {
        let params = {uid: resaAuth, ...cardValue};
        return this.apiService.post(routes.sendCard, params)
//            .pipe(map((res: any) => {
//                return res
//            }))
        ;
    }
    
    /**
     * sendCard
     */
    sendCard(resaAuth: string, cardValue) {
        let params = {uid: resaAuth, card: cardValue,idetab:this.winRef.appConfigSite.idEtab};
        return this.apiService.post(routes.sendCardNormal, params)
//            .pipe(map((res: any) => {
//                return res
//            }))
        ;
    }
}
